import { Navigate, Route, Routes } from 'react-router-dom'
import { LogsConsultaListWrapper } from './logs-consulta-list/LogsConsultaList'
import { LogsUsuarioListWrapper } from './logs-usuario-list/LogsUsuarioList'
import { LogsConsultaIdListWrapper } from './logs-consulta-id/LogsConsultaIdList'
import { LogsUsuarioIdListWrapper } from './logs-usuario-id/LogsUsuarioIdList'
import { PageLink, PageTitle } from '_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'

const consultaBreadcrumbs: Array<PageLink> = [
  {
    title: 'Logs por consulta',
    path: '/apps/admin/logs/consulta',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const usuarioBreadcrumbs: Array<PageLink> = [
  {
    title: 'Logs por usuário',
    path: '/apps/admin/logs/usuario',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const LogsPage = () => {
  const { t } = useT()

  return (
    <Routes>
      <Route
        path='consulta'
        element={
          <>
            <PageTitle description={t('pagina.logsConsulta.descricao')}>
              Logs por consulta
            </PageTitle>
            <LogsConsultaListWrapper />
          </>
        }
      />
      <Route
        path='consulta/:id'
        element={
          <>
            <PageTitle breadcrumbs={consultaBreadcrumbs}>Logs do atendimento</PageTitle>
            <LogsConsultaIdListWrapper />
          </>
        }
      />
      <Route
        path='usuario'
        element={
          <>
            <PageTitle description={t('pagina.logsUsuario.descricao')}>Logs por usuário</PageTitle>
            <LogsUsuarioListWrapper />
          </>
        }
      />
      <Route
        path='usuario/:id'
        element={
          <>
            <PageTitle breadcrumbs={usuarioBreadcrumbs}>Logs do usuário</PageTitle>
            <LogsUsuarioIdListWrapper />
          </>
        }
      />

      <Route index element={<Navigate to='/apps/admin/logs/consulta' />} />
    </Routes>
  )
}

export default LogsPage
